import * as React from "react"
import { $mobile } from "../../utils/breakpoints"
import { Section, Container } from "../StyledComponents/layoutComponentStyles"

// Styles
import "./_post-video.scss"

// Components

// Animations

interface PostVideoProps {
  module: any
}

/* 









*/

const PostVideo: React.FunctionComponent<PostVideoProps> = ({ module }) => {
  return (
    <Section>
      <Container sixteenClm={!$mobile}>
        <div className='c-post-video'>
          <video muted loop autoPlay playsInline className='c-post-video__asset' src={module.asset.url}>
            <source src={module.asset.url} type='video/mp4'></source>
          </video>
        </div>
      </Container>
    </Section>
  )
}

export default PostVideo
